// Global Instructions Rule Applied!

import { DistributionListsState, DistributionListsAction } from '../../interfaces/distribution_lists.ts'
import { CommsTopicGridModelFields } from '../../data_models/comms_topic_grid_model.ts'
import {
  SET_TOPICS,
  SET_ACTIVE_FILTERS,
  SET_ACTIVE_SORTING,
  CLEAR_ACTIVE_FILTERS,
  ADD_TOPIC,
  UPDATE_TOPIC_RECORD,
  REMOVE_TOPIC
} from './constants.ts'

const distributionListsReducer = (
  state: DistributionListsState = {
    activeFilters: [],
    activeSorting: [],
    data: [],
    hasMore: false,
    currentPage: 1
  },
  action: DistributionListsAction
): DistributionListsState => {
  switch (action.type) {
    case SET_TOPICS: {
      const { response } = (action as { payload: { response: { data: any[]; hasMore: boolean } } }).payload
      return {
        ...state,
        data: response.data,
        hasMore: response.hasMore,
        currentPage: 1
      }
    }

    case SET_ACTIVE_FILTERS: {
      const { filters } = (action as { payload: { filters: any[] } }).payload
      return { ...state, activeFilters: filters }
    }

    case SET_ACTIVE_SORTING: {
      const { sorting } = (action as { payload: { sorting: any[] } }).payload
      return { ...state, activeSorting: sorting }
    }

    case CLEAR_ACTIVE_FILTERS: {
      return { ...state, activeFilters: [] }
    }

    case ADD_TOPIC: {
      const { topic } = (action as { payload: { topic: any } }).payload
      return { ...state, data: [topic, ...state.data] }
    }

    case UPDATE_TOPIC_RECORD: {
      const { topicId, updates } = (action as { payload: { topicId: string; updates: Record<string, any> } })
        .payload
      const idKey = CommsTopicGridModelFields.comms_topics__id
      return {
        ...state,
        data: state.data.map((topic) =>
          (topic as any)[idKey] === topicId ? { ...topic, ...updates } : topic
        )
      }
    }

    case REMOVE_TOPIC: {
      const { topicId } = (action as { payload: { topicId: string } }).payload
      const idKey = CommsTopicGridModelFields.comms_topics__id
      return {
        ...state,
        data: state.data.filter((topic) => (topic as any)[idKey] !== topicId)
      }
    }

    default:
      return state
  }
}

export default distributionListsReducer
export * from './dl_actions.ts'
